import { noop, omit } from "lodash";
import React from "react";
import styled from "styled-components";
import { colours } from "../../styles/colours";
import { device } from "../../styles/media";
import { Icon } from "../icons";
import { Flex } from "../layout";
import { Widget, WidgetProps } from "../widget";

const Container = styled(Flex).attrs({ center: true })`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  color: ${colours.white};
  z-index: 1;
`;

export type OverlayProps = React.ComponentProps<typeof Container>;

export const Overlay = React.forwardRef<HTMLDivElement, OverlayProps>(
  (props, ref) => <Container ref={ref} {...props} />
);

export type ModalProps = React.ComponentProps<typeof Overlay> & {
  title: WidgetProps["title"];
  onDismiss?: () => void;
};

const ContainedWidget = styled(Widget)`
  width: 90%;
  height: 80%;
  display: flex;
  flex-direction: column;

  @media ${device.tablet} {
    width: auto;
    height: auto;
    max-height: 80%;
    max-width: 40em;
  }
  @media ${device.laptop} {
    max-width: 60em;
  }
`;

export const Modal = React.forwardRef<HTMLDivElement, ModalProps>(
  (props, ref) => {
    const propsToPass = omit(props, "title", "children", "onDismiss");
    const { title, children, onDismiss } = props;
    return (
      <Container ref={ref} {...propsToPass} onClick={onDismiss || noop}>
        <ContainedWidget
          onClick={(e) => e.stopPropagation()}
          title={title}
          adornment={
            onDismiss ? <Icon onClick={onDismiss} type="close" /> : null
          }
        >
          {children}
        </ContainedWidget>
      </Container>
    );
  }
);
